import { Service, inject } from '@angular/core';
import { BaseService } from '@bfy/bfy-ui-shared';
import { Observable } from 'rxjs';
import {
    GetTargetDateFundRequestVm,
    GetTargetDateFundResponseVm,
    PreEnrollEnrollmentRequestVm,
    PreEnrollmentAdminDetailsVm,
    PreEnrollmentDetailsVm,
} from '../pre-enrollment/pre-enrollment.viewmodel';

const BASE_URL = '/root/Pre-Enrollment';
const SAVEPREENROLLMENT_URL = 'v1/SavePreEnrollmentDetails';
const GETPREENROLLMENT_URL = 'v1/GetPreEnrollmentPlanId';
const GETTARGETDATEFUNDS_URL = 'v1/GetTargetDateFunds';

@Service()
export class PreEnrollmentService {
    private baseService = inject(BaseService);
    private preEnrollmentDetail: PreEnrollEnrollmentRequestVm = new PreEnrollEnrollmentRequestVm();
    private preEnrollmentAdminDetail: PreEnrollmentAdminDetailsVm =
        new PreEnrollmentAdminDetailsVm();

    // Getters and Setters for PreEnrollmentSummaryPage
    getPreEnrollmentDetail(): PreEnrollEnrollmentRequestVm {
        return this.preEnrollmentDetail;
    }

    setPreEnrollmentDetail(preEnrollmentDetail: PreEnrollEnrollmentRequestVm): void {
        this.preEnrollmentDetail = preEnrollmentDetail;
    }

    getPreEnrollmentAdminDetail(): PreEnrollmentAdminDetailsVm {
        return this.preEnrollmentAdminDetail;
    }

    setPreEnrollmentAdminDetail(preEnrollmentAdminDetail: PreEnrollmentAdminDetailsVm): void {
        this.preEnrollmentAdminDetail = preEnrollmentAdminDetail;
    }

    // This method is used to determine if the user is on the pre-enrollment page
    // If not, then do not allow navigation to the pre-enrollment summary page
    isUserInPreEnrollmentPage(): boolean {
        // The only time this value is set within the session is when the user navigates to the pre-enrollment summary page
        const isInPreEnrollmentPage = !!this.preEnrollmentDetail?.planId?.length;
        return isInPreEnrollmentPage;
    }

    savePreEnrollment(preEnrollment: PreEnrollEnrollmentRequestVm): Observable<any> {
        const url = `${BASE_URL}/${SAVEPREENROLLMENT_URL}`;
        return this.baseService.post(url, preEnrollment);
    }

    getPreEnrollmentPlanId(id: string): Observable<PreEnrollmentDetailsVm> {
        const url = `${BASE_URL}/${GETPREENROLLMENT_URL}/${id}`;
        return this.baseService.get(url);
    }

    getTargetDateFundsByDob(
        request: GetTargetDateFundRequestVm,
    ): Observable<GetTargetDateFundResponseVm> {
        const url = `${BASE_URL}/${GETTARGETDATEFUNDS_URL}`;
        return this.baseService.post(url, request);
    }
}
